import { render } from "./lonjas.vue?vue&type=template&id=28888204&scoped=true"
import script from "./lonjas.vue?vue&type=script&lang=js"
export * from "./lonjas.vue?vue&type=script&lang=js"

import "./lonjas.vue?vue&type=style&index=0&id=28888204&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28888204"]])

export default __exports__